import { render, staticRenderFns } from "./TariffsTable.vue?vue&type=template&id=24f753f0&"
import script from "./TariffsTable.vue?vue&type=script&lang=ts&"
export * from "./TariffsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports